// Maps a plan key (general-api's `account.plan`) to a human display name.
//
// general-api returns the plan *key* (e.g. "pro-yearly"); the member table
// needs the label (e.g. "Pro Yearly"). Mirrors the name table in
// stpancras-presenter-app/src/pricing.js — names only, none of the
// pricing/colour/limit data, which the table doesn't need.

const PLAN_NAMES: Record<string, string> = {
  free: "Free",
  "white-label": "White Label",
  "essential-monthly": "Essential Monthly",
  "essential-yearly": "Essential Yearly",
  "plus-monthly": "Plus Monthly",
  "plus-yearly": "Plus Yearly",
  "pro-monthly": "Pro Monthly",
  "pro-yearly": "Pro Yearly",
  "edu-small": "Edu (Small)",
  "edu-small-monthly": "Edu (Small)",
  "edu-small-yearly": "Edu (Small)",
  "edu-medium": "Edu (Medium)",
  "edu-medium-monthly": "Edu (Medium)",
  "edu-medium-yearly": "Edu (Medium)",
  "edu-large": "Edu (Large)",
  "edu-large-monthly": "Edu (Large)",
  "edu-large-yearly": "Edu (Large)",
  "trial-plus-monthly": "Trial Plus",
  "trial-pro-monthly": "Trial Pro",
};

// Resolve a plan key to its display name. Legacy/regional variants
// ("pro-yearly-eu", "pro-yearly-24122019") collapse to their canonical key;
// anything still unknown falls back to a title-cased version of the key so it
// always renders something readable.
export function getPlanDisplayName(plan: string | null | undefined): string {
  if (!plan) return "";
  if (PLAN_NAMES[plan]) return PLAN_NAMES[plan];
  const canonical = plan.replace(/-eu$/, "").replace(/-\d+$/, "");
  if (PLAN_NAMES[canonical]) return PLAN_NAMES[canonical];
  return plan.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
